import classNames from 'classnames';
import React from 'react';

const Label = ({ className, ...props }) => (
  <div className={classNames('label', className)}>{props.children}</div>
);

export default Label;



// WEBPACK FOOTER //
// ./app/javascript/apps/account/components/shared/Label.js